import { Autocomplete, TextField } from "@mui/material";
import { Col, Row, Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";

export default function SearchVenues(props) {

    const [loading, setLoading] = useState(true)
    const [venueId] = useState()
    const [keyChange, setKey] = useState(0)

    useEffect(() => {
        const loadVenues = async () => {
          setLoading(false)
          setKey(props.keyChange)
        }
        loadVenues();
      }, [props.venueData, props.keyChange])

      const displayVenueSearch = () => {
        if (!loading) {
          return (
            <Col md={6} className='mb-3'>
              <Autocomplete
                value={venueId}
                onChange={(event, newValue) => {
                    props.handleVenueChange(newValue)
                }}
                disablePortal
                id="combo-box-edit-event-venue-search"
                options={props.venueData}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                key = {keyChange}
                renderInput={(params) => <TextField {...params} label="Venue" />}
              />
    
            </Col>
    
          )
        }
        else{
            return(
                <Spinner animation="grow" variant="primary"/>
            )
        }
      }

  return (
    
    <Row>
    {displayVenueSearch()}
    </Row>
  );
}